//@flow
import FunctionStore from '../Base/functionStoreClass';
import Constants from '../../constants';
import CookiesData from '../../Utils/cookies-data';
import { updateState } from '../Base/storeUtils';
import { toJS, toImmutable } from '../../Utils/immutable';

import type { HandlerAdd, StoreState } from '../Base/functionStoreClass';

export default class ExperimentsStore extends FunctionStore {
  isEnabled(name:string):boolean {
    return !!_getExperiment(this.getState(), name);
  }

  getExperimentVersion(name:string):?string {
    const val = _getExperiment(this.getState(), name);
    if (typeof val === 'number') return String(val);
    return val || null;
  }

  _setup(onSuccess:HandlerAdd, onError:HandlerAdd) {
    onSuccess(Constants.ENABLE_EXPERIMENT, updateState(_enableExperiments));
    onSuccess(Constants.DISABLE_ALL_EXPERIMENTS, updateState(_disableAllExperiments));
  }
}

function _getExperiment(state:StoreState, name:string) {
  return state.getIn(['experiments', name]);
}

function _enableExperiments(state:StoreState, data:{
  experiments:string|string[]|Object[]|Object,
  version:?string|boolean,
 }) {
  const version = data.version === undefined ? true : data.version;

  const newExperiments = [].concat(data.experiments);
  newExperiments.forEach((item) => {
    if (typeof item === 'string' && _getExperiment(state, item) !== version) {
      state.setIn(['experiments', item], version);
    } else if (typeof item === 'object') {
      if (item.name) {
        state.setIn(['experiments', item.name], item.version === undefined ? true : item.version);
      }
      else {
        state.mergeIn(['experiments'], toImmutable(item));
      }
    }
  });

  CookiesData.setExperiments(toJS(state.get('experiments')));
}

function _disableAllExperiments(state:StoreState) {
  CookiesData.disableAllExperiments();
  state.delete('experiments');
}
